/**
 * @packageDocumentation
 * @module HackerAPI.User.Hacker.TravelInfo
 */
import { __extends } from "tslib";
import Base from "../../../base/base";
import { parseDate } from "../../../utils/utils";
/**
 * A data container for things related to how the hacker is getting to the event
 * @struct
 * @extends { HackerAPI.Base }
 */
var TravelInfo = /** @class */ (function (_super) {
    __extends(TravelInfo, _super);
    /**
     * Creates a TravelInfo instance
     * @constructor
     * @param travelInfo
     */
    function TravelInfo(_a) {
        var _b = _a === void 0 ? {} : _a, closest_airport = _b.closest_airport, closestAirport = _b.closestAirport, passport_number = _b.passport_number, passportNumber = _b.passportNumber, citizenship_country = _b.citizenship_country, citizenshipCountry = _b.citizenshipCountry, visa_country = _b.visa_country, visaCountry = _b.visaCountry, issue_date = _b.issue_date, issueDate = _b.issueDate, expiry_date = _b.expiry_date, expiryDate = _b.expiryDate, visa_type = _b.visa_type, visaType = _b.visaType, current_city = _b.current_city, currentCity = _b.currentCity;
        var _this = _super.call(this, {
            expiryDate: Base.dateHandler,
            issueDate: Base.dateHandler
        }) || this;
        /**
         * @type { string }
         */
        _this.closestAirport = closest_airport || closestAirport || null;
        /**
         * @type { string }
         */
        _this.passportNumber = passport_number || passportNumber || null;
        /**
         * @type { string }
         */
        _this.citizenshipCountry = citizenship_country || citizenshipCountry || null;
        /**
         * @type { string }
         */
        _this.visaCountry = visa_country || visaCountry || null;
        /**
         * @type { Date }
         */
        _this.issueDate = parseDate(issue_date || issueDate) || null;
        /**
         * @type { Date }
         */
        _this.expiryDate = parseDate(expiry_date || expiryDate) || null;
        /**
         * @type { string }
         */
        _this.visaType = visa_type || visaType || null;
        /**
         * @type { string }
         */
        _this.currentCity = current_city || currentCity || null;
        return _this;
    }
    return TravelInfo;
}(Base));
export default TravelInfo;
//# sourceMappingURL=travel-info.js.map